/// <amd-module name="VSS/ExtServices/RestClient/ExtensionManagement" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\web\extensions\vss-features\vss-extensibility\vss-ext-services\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as ExtensionManagement from "../Contracts/ExtensionManagement";
import * as GalleryWebApi from "../Contracts/Gallery";

export interface IExtensionManagementRestClient extends IVssRestClient {
    /**
     * This API is called by acquisition/install page to get possible user actions like Buy/Request
     * 
     * @param itemId - Fully qualified name of extension (\<publisher_id\>.\<extension_id\>)
     * @param testCommerce - Parameter to test paid preview extension without making azure plans public
     * @param isFreeOrTrialInstall - Parameter represents install or trial workflow (required for legacy install flows)
     * @param isAccountOwner - Parameter represents whether user is owner or PCA of an account
     * @param isLinked - Parameter represents whether account is linked with a subscription
     * @param isConnectedServer - Parameter represents whether Buy operation should be evaluated
     * @param isBuyOperationValid - 
     */
    getAcquisitionOptions(itemId: string, testCommerce?: boolean, isFreeOrTrialInstall?: boolean, isAccountOwner?: boolean, isLinked?: boolean, isConnectedServer?: boolean, isBuyOperationValid?: boolean): Promise<ExtensionManagement.AcquisitionOptions>;
    /**
     * @param acquisitionRequest - 
     */
    requestAcquisition(acquisitionRequest: ExtensionManagement.ExtensionAcquisitionRequest): Promise<ExtensionManagement.ExtensionAcquisitionRequest>;
    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param registrationId - 
     */
    registerAuthorization(publisherName: string, extensionName: string, registrationId: string): Promise<ExtensionManagement.ExtensionAuthorization>;
    /**
     * @param doc - 
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     */
    createDocumentByName(doc: any, publisherName: string, extensionName: string, scopeType: string, scopeValue: string, collectionName: string): Promise<any>;
    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     * @param documentId - 
     */
    deleteDocumentByName(publisherName: string, extensionName: string, scopeType: string, scopeValue: string, collectionName: string, documentId: string): Promise<void>;
    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     * @param documentId - 
     */
    getDocumentByName(publisherName: string, extensionName: string, scopeType: string, scopeValue: string, collectionName: string, documentId: string): Promise<any>;
    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     */
    getDocumentsByName(publisherName: string, extensionName: string, scopeType: string, scopeValue: string, collectionName: string): Promise<any[]>;
    /**
     * @param doc - 
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     */
    setDocumentByName(doc: any, publisherName: string, extensionName: string, scopeType: string, scopeValue: string, collectionName: string): Promise<any>;
    /**
     * @param doc - 
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     */
    updateDocumentByName(doc: any, publisherName: string, extensionName: string, scopeType: string, scopeValue: string, collectionName: string): Promise<any>;
    /**
     * Query for one or more data collections for the specified extension.  Note: the token used for authorization must have been issued on behalf of the specified extension.
     * 
     * @param collectionQuery - 
     * @param publisherName - Name of the publisher. Example: "fabrikam".
     * @param extensionName - Name of the extension. Example: "ops-tools".
     */
    queryCollectionsByName(collectionQuery: ExtensionManagement.ExtensionDataCollectionQuery, publisherName: string, extensionName: string): Promise<ExtensionManagement.ExtensionDataCollection[]>;
    /**
     * List state and version information for all installed extensions.
     * 
     * @param includeDisabled - If true (the default), include disabled extensions in the results.
     * @param includeErrors - If true, include installed extensions in an error state in the results.
     * @param includeInstallationIssues - 
     * @param forceRefresh - 
     */
    getStates(includeDisabled?: boolean, includeErrors?: boolean, includeInstallationIssues?: boolean, forceRefresh?: boolean): Promise<ExtensionManagement.ExtensionState[]>;
    /**
     * @param query - 
     */
    queryExtensions(query: ExtensionManagement.InstalledExtensionQuery): Promise<ExtensionManagement.InstalledExtension[]>;
    /**
     * List the installed extensions in the account / project collection.
     * 
     * @param includeDisabledExtensions - If true (the default), include disabled extensions in the results.
     * @param includeErrors - If true, include installed extensions with errors.
     * @param assetTypes - Determines which files are returned in the files array.  Provide the wildcard '*' to return all files, or a colon separated list to retrieve files with specific asset types.
     * @param includeInstallationIssues - 
     */
    getInstalledExtensions(includeDisabledExtensions?: boolean, includeErrors?: boolean, assetTypes?: string[], includeInstallationIssues?: boolean): Promise<ExtensionManagement.InstalledExtension[]>;
    /**
     * Update an installed extension. Typically this API is used to enable or disable an extension.
     * 
     * @param extension - 
     */
    updateInstalledExtension(extension: ExtensionManagement.InstalledExtension): Promise<ExtensionManagement.InstalledExtension>;
    /**
     * Get an installed extension by its publisher and extension name.
     * 
     * @param publisherName - Name of the publisher. Example: "fabrikam".
     * @param extensionName - Name of the extension. Example: "ops-tools".
     * @param assetTypes - Determines which files are returned in the files array.  Provide the wildcard '*' to return all files, or a colon separated list to retrieve files with specific asset types.
     */
    getInstalledExtensionByName(publisherName: string, extensionName: string, assetTypes?: string[]): Promise<ExtensionManagement.InstalledExtension>;
    /**
     * Install the specified extension into the account / project collection.
     * 
     * @param publisherName - Name of the publisher. Example: "fabrikam".
     * @param extensionName - Name of the extension. Example: "ops-tools".
     * @param version - 
     */
    installExtensionByName(publisherName: string, extensionName: string, version?: string): Promise<ExtensionManagement.InstalledExtension>;
    /**
     * Uninstall the specified extension from the account / project collection.
     * 
     * @param publisherName - Name of the publisher. Example: "fabrikam".
     * @param extensionName - Name of the extension. Example: "ops-tools".
     * @param reason - 
     * @param reasonCode - 
     */
    uninstallExtensionByName(publisherName: string, extensionName: string, reason?: string, reasonCode?: string): Promise<void>;
    /**
     * @param userId - 
     */
    getPolicies(userId: string): Promise<GalleryWebApi.UserExtensionPolicy>;
    /**
     * @param rejectMessage - 
     * @param publisherName - 
     * @param extensionName - 
     * @param requesterId - 
     * @param state - 
     */
    resolveRequest(rejectMessage: string, publisherName: string, extensionName: string, requesterId: string, state: ExtensionManagement.ExtensionRequestState): Promise<number>;
    /**
     */
    getRequests(): Promise<ExtensionManagement.RequestedExtension[]>;
    /**
     * @param rejectMessage - 
     * @param publisherName - 
     * @param extensionName - 
     * @param state - 
     */
    resolveAllRequests(rejectMessage: string, publisherName: string, extensionName: string, state: ExtensionManagement.ExtensionRequestState): Promise<number>;
    /**
     * @param publisherName - 
     * @param extensionName - 
     */
    deleteRequest(publisherName: string, extensionName: string): Promise<void>;
    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param requestMessage - 
     */
    requestExtension(publisherName: string, extensionName: string, requestMessage: string): Promise<ExtensionManagement.RequestedExtension>;
    /**
     */
    getToken(): Promise<string>;
}

class ExtensionManagementRestClient extends RestClientBase implements IExtensionManagementRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * This API is called by acquisition/install page to get possible user actions like Buy/Request
     * 
     * @param itemId - Fully qualified name of extension (\<publisher_id\>.\<extension_id\>)
     * @param testCommerce - Parameter to test paid preview extension without making azure plans public
     * @param isFreeOrTrialInstall - Parameter represents install or trial workflow (required for legacy install flows)
     * @param isAccountOwner - Parameter represents whether user is owner or PCA of an account
     * @param isLinked - Parameter represents whether account is linked with a subscription
     * @param isConnectedServer - Parameter represents whether Buy operation should be evaluated
     * @param isBuyOperationValid - 
     */
    public async getAcquisitionOptions(
        itemId: string,
        testCommerce?: boolean,
        isFreeOrTrialInstall?: boolean,
        isAccountOwner?: boolean,
        isLinked?: boolean,
        isConnectedServer?: boolean,
        isBuyOperationValid?: boolean
        ): Promise<ExtensionManagement.AcquisitionOptions> {

        const queryValues: any = {
            itemId: itemId,
            testCommerce: testCommerce,
            isFreeOrTrialInstall: isFreeOrTrialInstall,
            isAccountOwner: isAccountOwner,
            isLinked: isLinked,
            isConnectedServer: isConnectedServer,
            isBuyOperationValid: isBuyOperationValid
        };

        return this.beginRequest<ExtensionManagement.AcquisitionOptions>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/AcquisitionOptions",
            queryParams: queryValues
        });
    }

    /**
     * @param acquisitionRequest - 
     */
    public async requestAcquisition(
        acquisitionRequest: ExtensionManagement.ExtensionAcquisitionRequest
        ): Promise<ExtensionManagement.ExtensionAcquisitionRequest> {

        return this.beginRequest<ExtensionManagement.ExtensionAcquisitionRequest>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/ExtensionManagement/AcquisitionRequests",
            body: acquisitionRequest
        });
    }

    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param registrationId - 
     */
    public async registerAuthorization(
        publisherName: string,
        extensionName: string,
        registrationId: string
        ): Promise<ExtensionManagement.ExtensionAuthorization> {

        return this.beginRequest<ExtensionManagement.ExtensionAuthorization>({
            apiVersion: "3.2-preview.1",
            method: "PUT",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{publisherName}/{extensionName}/Authorizations/{registrationId}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                registrationId: registrationId
            }
        });
    }

    /**
     * @param doc - 
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     */
    public async createDocumentByName(
        doc: any,
        publisherName: string,
        extensionName: string,
        scopeType: string,
        scopeValue: string,
        collectionName: string
        ): Promise<any> {

        return this.beginRequest<any>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{publisherName}/{extensionName}/Data/Scopes/{scopeType}/{scopeValue}/Collections/{collectionName}/Documents/{documentId}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                scopeType: scopeType,
                scopeValue: scopeValue,
                collectionName: collectionName
            },
            body: doc
        });
    }

    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     * @param documentId - 
     */
    public async deleteDocumentByName(
        publisherName: string,
        extensionName: string,
        scopeType: string,
        scopeValue: string,
        collectionName: string,
        documentId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "3.2-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{publisherName}/{extensionName}/Data/Scopes/{scopeType}/{scopeValue}/Collections/{collectionName}/Documents/{documentId}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                scopeType: scopeType,
                scopeValue: scopeValue,
                collectionName: collectionName,
                documentId: documentId
            }
        });
    }

    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     * @param documentId - 
     */
    public async getDocumentByName(
        publisherName: string,
        extensionName: string,
        scopeType: string,
        scopeValue: string,
        collectionName: string,
        documentId: string
        ): Promise<any> {

        return this.beginRequest<any>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{publisherName}/{extensionName}/Data/Scopes/{scopeType}/{scopeValue}/Collections/{collectionName}/Documents/{documentId}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                scopeType: scopeType,
                scopeValue: scopeValue,
                collectionName: collectionName,
                documentId: documentId
            }
        });
    }

    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     */
    public async getDocumentsByName(
        publisherName: string,
        extensionName: string,
        scopeType: string,
        scopeValue: string,
        collectionName: string
        ): Promise<any[]> {

        return this.beginRequest<any[]>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{publisherName}/{extensionName}/Data/Scopes/{scopeType}/{scopeValue}/Collections/{collectionName}/Documents/{documentId}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                scopeType: scopeType,
                scopeValue: scopeValue,
                collectionName: collectionName
            }
        });
    }

    /**
     * @param doc - 
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     */
    public async setDocumentByName(
        doc: any,
        publisherName: string,
        extensionName: string,
        scopeType: string,
        scopeValue: string,
        collectionName: string
        ): Promise<any> {

        return this.beginRequest<any>({
            apiVersion: "3.2-preview.1",
            method: "PUT",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{publisherName}/{extensionName}/Data/Scopes/{scopeType}/{scopeValue}/Collections/{collectionName}/Documents/{documentId}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                scopeType: scopeType,
                scopeValue: scopeValue,
                collectionName: collectionName
            },
            body: doc
        });
    }

    /**
     * @param doc - 
     * @param publisherName - 
     * @param extensionName - 
     * @param scopeType - 
     * @param scopeValue - 
     * @param collectionName - 
     */
    public async updateDocumentByName(
        doc: any,
        publisherName: string,
        extensionName: string,
        scopeType: string,
        scopeValue: string,
        collectionName: string
        ): Promise<any> {

        return this.beginRequest<any>({
            apiVersion: "3.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{publisherName}/{extensionName}/Data/Scopes/{scopeType}/{scopeValue}/Collections/{collectionName}/Documents/{documentId}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                scopeType: scopeType,
                scopeValue: scopeValue,
                collectionName: collectionName
            },
            body: doc
        });
    }

    /**
     * Query for one or more data collections for the specified extension.  Note: the token used for authorization must have been issued on behalf of the specified extension.
     * 
     * @param collectionQuery - 
     * @param publisherName - Name of the publisher. Example: "fabrikam".
     * @param extensionName - Name of the extension. Example: "ops-tools".
     */
    public async queryCollectionsByName(
        collectionQuery: ExtensionManagement.ExtensionDataCollectionQuery,
        publisherName: string,
        extensionName: string
        ): Promise<ExtensionManagement.ExtensionDataCollection[]> {

        return this.beginRequest<ExtensionManagement.ExtensionDataCollection[]>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{publisherName}/{extensionName}/ExtensionDataCollectionQuery",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName
            },
            body: collectionQuery
        });
    }

    /**
     * List state and version information for all installed extensions.
     * 
     * @param includeDisabled - If true (the default), include disabled extensions in the results.
     * @param includeErrors - If true, include installed extensions in an error state in the results.
     * @param includeInstallationIssues - 
     * @param forceRefresh - 
     */
    public async getStates(
        includeDisabled?: boolean,
        includeErrors?: boolean,
        includeInstallationIssues?: boolean,
        forceRefresh?: boolean
        ): Promise<ExtensionManagement.ExtensionState[]> {

        const queryValues: any = {
            includeDisabled: includeDisabled,
            includeErrors: includeErrors,
            includeInstallationIssues: includeInstallationIssues,
            forceRefresh: forceRefresh
        };

        return this.beginRequest<ExtensionManagement.ExtensionState[]>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/ExtensionStates",
            queryParams: queryValues
        });
    }

    /**
     * @param query - 
     */
    public async queryExtensions(
        query: ExtensionManagement.InstalledExtensionQuery
        ): Promise<ExtensionManagement.InstalledExtension[]> {

        return this.beginRequest<ExtensionManagement.InstalledExtension[]>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensionQuery",
            body: query
        });
    }

    /**
     * List the installed extensions in the account / project collection.
     * 
     * @param includeDisabledExtensions - If true (the default), include disabled extensions in the results.
     * @param includeErrors - If true, include installed extensions with errors.
     * @param assetTypes - Determines which files are returned in the files array.  Provide the wildcard '*' to return all files, or a colon separated list to retrieve files with specific asset types.
     * @param includeInstallationIssues - 
     */
    public async getInstalledExtensions(
        includeDisabledExtensions?: boolean,
        includeErrors?: boolean,
        assetTypes?: string[],
        includeInstallationIssues?: boolean
        ): Promise<ExtensionManagement.InstalledExtension[]> {

        const queryValues: any = {
            includeDisabledExtensions: includeDisabledExtensions,
            includeErrors: includeErrors,
            assetTypes: assetTypes && assetTypes.join(":"),
            includeInstallationIssues: includeInstallationIssues
        };

        return this.beginRequest<ExtensionManagement.InstalledExtension[]>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{extensionId}",
            queryParams: queryValues
        });
    }

    /**
     * Update an installed extension. Typically this API is used to enable or disable an extension.
     * 
     * @param extension - 
     */
    public async updateInstalledExtension(
        extension: ExtensionManagement.InstalledExtension
        ): Promise<ExtensionManagement.InstalledExtension> {

        return this.beginRequest<ExtensionManagement.InstalledExtension>({
            apiVersion: "3.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensions/{extensionId}",
            body: extension
        });
    }

    /**
     * Get an installed extension by its publisher and extension name.
     * 
     * @param publisherName - Name of the publisher. Example: "fabrikam".
     * @param extensionName - Name of the extension. Example: "ops-tools".
     * @param assetTypes - Determines which files are returned in the files array.  Provide the wildcard '*' to return all files, or a colon separated list to retrieve files with specific asset types.
     */
    public async getInstalledExtensionByName(
        publisherName: string,
        extensionName: string,
        assetTypes?: string[]
        ): Promise<ExtensionManagement.InstalledExtension> {

        const queryValues: any = {
            assetTypes: assetTypes && assetTypes.join(":")
        };

        return this.beginRequest<ExtensionManagement.InstalledExtension>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensionsByName/{publisherName}/{extensionName}/{version}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName
            },
            queryParams: queryValues
        });
    }

    /**
     * Install the specified extension into the account / project collection.
     * 
     * @param publisherName - Name of the publisher. Example: "fabrikam".
     * @param extensionName - Name of the extension. Example: "ops-tools".
     * @param version - 
     */
    public async installExtensionByName(
        publisherName: string,
        extensionName: string,
        version?: string
        ): Promise<ExtensionManagement.InstalledExtension> {

        return this.beginRequest<ExtensionManagement.InstalledExtension>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensionsByName/{publisherName}/{extensionName}/{version}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                version: version
            }
        });
    }

    /**
     * Uninstall the specified extension from the account / project collection.
     * 
     * @param publisherName - Name of the publisher. Example: "fabrikam".
     * @param extensionName - Name of the extension. Example: "ops-tools".
     * @param reason - 
     * @param reasonCode - 
     */
    public async uninstallExtensionByName(
        publisherName: string,
        extensionName: string,
        reason?: string,
        reasonCode?: string
        ): Promise<void> {

        const queryValues: any = {
            reason: reason,
            reasonCode: reasonCode
        };

        return this.beginRequest<void>({
            apiVersion: "3.2-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/ExtensionManagement/InstalledExtensionsByName/{publisherName}/{extensionName}/{version}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName
            },
            queryParams: queryValues
        });
    }

    /**
     * @param userId - 
     */
    public async getPolicies(
        userId: string
        ): Promise<GalleryWebApi.UserExtensionPolicy> {

        return this.beginRequest<GalleryWebApi.UserExtensionPolicy>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/Policies/{userId}",
            routeValues: {
                userId: userId
            }
        });
    }

    /**
     * @param rejectMessage - 
     * @param publisherName - 
     * @param extensionName - 
     * @param requesterId - 
     * @param state - 
     */
    public async resolveRequest(
        rejectMessage: string,
        publisherName: string,
        extensionName: string,
        requesterId: string,
        state: ExtensionManagement.ExtensionRequestState
        ): Promise<number> {

        const queryValues: any = {
            state: state
        };

        return this.beginRequest<number>({
            apiVersion: "3.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/ExtensionManagement/RequestedExtensions/{publisherName}/{extensionName}/requests/{requesterId}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName,
                requesterId: requesterId
            },
            queryParams: queryValues,
            body: rejectMessage
        });
    }

    /**
     */
    public async getRequests(
        ): Promise<ExtensionManagement.RequestedExtension[]> {

        return this.beginRequest<ExtensionManagement.RequestedExtension[]>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/RequestedExtensions"
        });
    }

    /**
     * @param rejectMessage - 
     * @param publisherName - 
     * @param extensionName - 
     * @param state - 
     */
    public async resolveAllRequests(
        rejectMessage: string,
        publisherName: string,
        extensionName: string,
        state: ExtensionManagement.ExtensionRequestState
        ): Promise<number> {

        const queryValues: any = {
            state: state
        };

        return this.beginRequest<number>({
            apiVersion: "3.2-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/ExtensionManagement/RequestedExtensions/{publisherName}/{extensionName}",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName
            },
            queryParams: queryValues,
            body: rejectMessage
        });
    }

    /**
     * @param publisherName - 
     * @param extensionName - 
     */
    public async deleteRequest(
        publisherName: string,
        extensionName: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "3.2-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/ExtensionManagement/RequestedExtensions/{publisherName}/{extensionName}/requests/me",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName
            }
        });
    }

    /**
     * @param publisherName - 
     * @param extensionName - 
     * @param requestMessage - 
     */
    public async requestExtension(
        publisherName: string,
        extensionName: string,
        requestMessage: string
        ): Promise<ExtensionManagement.RequestedExtension> {

        return this.beginRequest<ExtensionManagement.RequestedExtension>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/ExtensionManagement/RequestedExtensions/{publisherName}/{extensionName}/requests/me",
            routeValues: {
                publisherName: publisherName,
                extensionName: extensionName
            },
            body: requestMessage
        });
    }

    /**
     */
    public async getToken(
        ): Promise<string> {

        return this.beginRequest<string>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/ExtensionManagement/Token"
        });
    }

}

export const ExtensionManagementClientName = "ExtensionManagementExtServices.IExtensionManagementRestClient";

export function getExtensionManagementClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IExtensionManagementRestClient {
    return pageContext.getRestClient<IExtensionManagementRestClient>(ExtensionManagementClientName, options);
}

RestClients.add(ExtensionManagementClientName, { 
    factory: ExtensionManagementRestClient,
    options: {
        resourceAreaId: "6c2b0933-3600-42ae-bf8b-93d4f7e83594",
        serviceInstanceType: "00000028-0000-8888-8000-000000000000"
    }
});
